export const navigateToLogin = () => {
  window.location.replace("/login");
};
